var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCustomError = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#F7491D",
  d: "M7.999 1.334A6.67 6.67 0 0 0 1.332 8a6.67 6.67 0 0 0 6.667 6.667A6.67 6.67 0 0 0 14.665 8 6.67 6.67 0 0 0 8 1.334m.666 10H7.332V10h1.333zm0-2.667H7.332v-4h1.333z"
})));
export { SvgCustomError as ReactComponent };
export default "/_next/static/images/CustomError.svg";